import "./index.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { Component } from "react";

import { RouteEn } from "./page/en/RouteEn"
import { RouteIt } from "./page/it/RouteIt"

class App extends Component {
	render() {
		return (
			<React.Fragment>
				<BrowserRouter>
					<Routes>
						<Route path="/*" element={<RouteIt />} />
						<Route path="/en/*" element={<RouteEn />} />

					</Routes>
				</BrowserRouter>
			</React.Fragment>
		);
	}
}

export default App;
